<template>
    <div>
        <slot v-bind="{ openProductEnrollmentsListModal }"></slot>
        <BaseModal
            :heading="`${product} Enrollments`"
            :opened="isOpen"
            @close="close"
            maxWidth="2xl"
        >
            <template v-slot:body>
                <div class="py-6 px-4">
                    <table class="-m-6">
                        <tr class="bg-gray-200">
                            <th class="text-left rounded-tl-md py-4 px-6 uppercase whitespace-nowrap">Course Title</th>
                            <th class="py-4 px-6 uppercase whitespace-nowrap">Course Status</th>
                            <th class="rounded-tr-md py-4 px-6 uppercase whitespace-nowrap">Has Access</th>
                        </tr>
                        <tr
                            v-for="e in courseEnrollments.values()"
                            class="even:bg-gray-50 text-sm"
                        >
                            <td class="p-6">
                                {{ e.title }}
                            </td>
                            <td class="p-6">
                                <div class=" flex justify-center">
                                    <div class="inline-flex items-center rounded-full text-2xs font-semibold uppercase leading-6 px-3 space-x-2 bg-green-50 text-green-700" v-if="e.status === 'published'">{{ e.status }}</div>
                                    <div class="inline-flex items-center rounded-full text-2xs font-semibold uppercase leading-6 px-3 space-x-2 bg-red-50 text-red-700" v-if="e.status === 'archived'">{{ e.status }}</div>
                                    <div class="inline-flex items-center rounded-full text-2xs font-semibold uppercase leading-6 px-3 space-x-2 bg-gray-50 text-gray-700" v-if="e.status === 'draft'">{{ e.status }}</div>
                                </div>
                            </td>
                            <td class="p-6">
                                <div class="flex justify-center">
                                    <div v-if="e.hasEnrollment" class="bg-green-700 text-white w-6 h-6 rounded-full flex items-center justify-center">
                                        <SvgIcon weight="bold" icon="check-line" size="sm"  />
                                    </div>
                                    <div v-else class="bg-red-700 text-white w-6 h-6 rounded-full flex items-center justify-center">
                                        <SvgIcon icon="close" size="sm" weight="bold" />
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script lang="ts">
import BaseModal from "./BaseModal.vue";
import {isAfter} from "date-fns";


export default {
    props: {
        courses: {
            type: Array,
            default: [],
        },
        enrollments: {
            type: Array,
            default: [],
        },
        product: String,
    },
    data(): any {
        return {
            isOpen: false,
        };
    },
    computed: {
       courseEnrollments() {
           const list = new Map();
            for (const course of this.courses) {
                const hasEnr = this.enrollments?.some(enrollment => enrollment.course_id === course.id && isAfter(new Date(enrollment.expires_at), new Date()));
                list.set(course.id, {
                    title: course.title,
                    status: course.status,
                    hasEnrollment: hasEnr
                });
            }

            return list;
       }
    },
    methods: {
        open() {
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
        },
        openProductEnrollmentsListModal() {
            this.open();
        },
    },

    components: {
        BaseModal,
    },
};
</script>
